module.exports = __webpack_public_path__ + "static/img/vanhemar.ae7d638.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/vanhemar.png
// module id = IOST
// module chunks = 0